import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { GamesService } from '../../../services/games.service';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { PointStorePermissionService } from 'src/app/gamification/marketplace/admin/services/point-store-permission.service';
import { AliasPageName } from 'src/app/gamification/cv-marketplace-admin/models/gamification-pages.model';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
    selector: 'cv-games-add-edit',
    templateUrl: './games-add-edit.component.html',
    styleUrls: ['./games-add-edit.component.scss']
})
export class GamesAddEditComponent implements OnInit {
    @Output() evtGameAdded: EventEmitter<any> = new EventEmitter<any>();
    @Output() evtGameChanged: EventEmitter<any> = new EventEmitter<any>();
    @Output() evtFlowCanceled: EventEmitter<void> = new EventEmitter<void>();

    @Input() isCxone: boolean = false;

    //Enums/object declarations
    views: any = Object.freeze({
        PickCategory: 1,//Option removed
        PickGameType: 2,
        ConfigureGame: 3
    });

    //Private variables
    gs: any = null;
    isCopy: boolean = false;
    flowMode: string = "create";
    selectedView: number = this.views.PickGameType;
    viewHistory: number[] = []

    constructor(
        private dialogService: CvDialogService,
        private gamesService: GamesService,
        private customDialogService: CvCustomDialogService,
        private pointStorePermissionService: PointStorePermissionService,
        private cvConfigurationService: CvConfigurationService
    ) {
        this.gs = this.gamesService.data;
        $(document).on('Event.Games.Setup.New', this.onNewGameClicked);
        $(document).on('Event.Games.Setup.Edit', this.onEditGameClicked);
        $(document).on('Event.Games.Setup.Copy', this.onCopyGameClicked);
    }

    ngOnInit(): void { }

    previousView(): void {
        if (this.flowMode == "edit") {
            // Set the views back to a default state
            this.selectedView = this.views.PickGameType;
            this.flowMode = "create";
            // Close the add/edit flow
            this.evtFlowCanceled.emit();
            this.scrollToTop();
        }

        switch (this.selectedView) {
            case this.views.ConfigureGame:
                if (this.isCxone) {
                    this.customDialogService.showDialog(
                        this.gamesService.getLocalizedMessage("Confirmation_Leave_Header", "Leave?"),
                        `<p class='modal-body-text'>${this.gamesService.getLocalizedMessage("Confirmation_Leave_Message", "All changes will be lost.")}</p>`,
                        11,
                        this.gamesService.getLocalizedMessage("Confirmation_Cancel_Button", "Stay"),
                        this.gamesService.getLocalizedMessage("Confirmation_Leave_Button", "Leave"),
                        true,
                        () => this.confirmCancelation(),
                        () => { },
                        "cxone-modal-game-warning",
                        true,
                        {
                            keyboard: false,
                            backdrop: "static",
                            centered: true,
                            windowClass: "cxone-create-warning-modal"
                        }
                    );
                } else {
                    this.dialogService.showConfirmDialog(
                        this.gamesService.getLocalizedMessage("Confirm_Add_Cancel_Title", "Go back?"),
                        this.gamesService.getLocalizedMessage("Confirm_Add_Cancel_Text", "Are you sure you want to go back? You will lose all unsaved changes."),
                        false,
                        () => this.confirmCancelation()
                    );
                }
                break;
            case this.views.PickGameType:
                this.evtFlowCanceled.emit();
                break;
        }
        if (!this.isCxone) {
            const stack = this.gamesService.getContextStack();
            const isExternalnavigation = stack.includes('history');
            const forceClean = isExternalnavigation;
            if (forceClean) {
                this.gamesService.clearContext();
                this.gamesService.pushContext('landing');
                this.gamesService.navigateTo({ type: 'back' });
            }
        }
    }


    confirmCancelation(): void {
        this.selectedView = this.views.PickGameType;
        this.scrollToTop();

        if (this.isCopy || (this.isCxone && this.gamesService.isCancelAction) ) {
            this.flowMode = "create";
            //close the add edit flow
            this.evtFlowCanceled.emit();
        }
    }

    nextView(): void {
        switch (this.selectedView) {
            case this.views.PickCategory: this.selectedView = this.views.PickGameType; break;
            case this.views.PickGameType: this.selectedView = this.views.ConfigureGame; break;
        }
    }

    categorySelected(category: number): void {
        this.gs.modified.SelectCategory(category);
        this.nextView();
    }

    async gametypeSelected(gameDef: any) {
        const hasCreatePermission: boolean = await this.pointStorePermissionService.validatePermission({
            name: this.pointStorePermissionService.getCreatePermissionName(),
            pageName: this.pointStorePermissionService.pageNameFilter(AliasPageName.GamesTab),
            newCXoneModalVersion: true
        }, !this.cvConfigurationService.isCxOne);
        if (!hasCreatePermission) {
            return;
        }
        //Set selected category
        this.gs.modified.SelectCategory(gameDef.Categories[0]);
        this.gs.modified.SelectGameDef(gameDef);
        this.gs.modified.NewConfiguration();
        this.nextView();
    }

    saveSuccessful(data: any): void {
        if (data.mode == 'create') {
            if (this.evtGameAdded != null && data.game != null)
                this.evtGameAdded.emit(data.game);
        }
        else { //edit
            if (this.evtGameChanged != null && data.game != null)
                this.evtGameChanged.emit(data.game);
        }
    }

    scrollToTop(): void {
        //Force a scroll to the top of the page since scrolling on configure pages causes odd scrolling
        window.scrollTo(0, 0);
    }

    private onNewGameClicked = (e: any) => {
        this.selectedView = this.views.PickGameType;
        this.isCopy = false;
        this.flowMode = "create";
        this.scrollToTop();
    }

    private onEditGameClicked = (e: any) => {
        this.selectedView = this.views.ConfigureGame;
        this.isCopy = false;
        this.flowMode = "edit";
        this.scrollToTop();
    }

    private onCopyGameClicked = (e: any) => {
        this.selectedView = this.views.ConfigureGame;
        this.isCopy = true;
        this.flowMode = "create";
        this.scrollToTop();
    }
}
